/**
 * SuperPanel navigation — platform admin + read-only operational views.
 */
const Menu = [
  {
    path: "/dashboard",
    icon: "fas fa-chart-line",
    title: "Dashboard",
    activeMatchPaths: ["/dashboard"],
  },
  {
    path: "/pond",
    icon: "fas fa-swimming-pool",
    title: "Pond",
    activeMatchPaths: [
      "/pond",
      "/updatePond/:id",
      "/pondFeedFertilization/:id",
      "/pondStocking/:id",
    ],
  },
  {
    path: "/fishingData",
    icon: "fa-solid fa-fish",
    title: "Fishing/Sampling Data",
    activeMatchPaths: [
      "/fishingData",
      "/sampling",
      "/pondDetailViaPond/:id",
      "/pondDetailOverview/:id",
      "/samplingViaPondDetail/:id",
      "/samplingGalleryViaPondDetail/:id",
      "/pondNoteViaPondDetail/:id",
      "/pondFishViaPondDetail/:id",
      "/FishDataTableView/:id",
      "/fish-data-graph-new/:id",
      "/pondNote",
    ],
  },
  {
    path: "/fishTypes",
    icon: "fa-solid fa-fish",
    title: "Fish Types",
    activeMatchPaths: ["/fishTypes"],
  },
  {
    title: "Units",
    path: "#",
    icon: "fa-solid fa-cogs",
    children: [
      {
        path: "/units/lengthUnits",
        icon: "fa-solid fa-ruler",
        title: "Length Unit",
        activeMatchPaths: ["/units/lengthUnits"],
      },
      {
        path: "/units/weightUnits",
        icon: "fa-solid fa-weight-hanging",
        title: "Weight Unit",
        activeMatchPaths: ["/units/weightUnits"],
      },
    ],
    activeMatchPaths: ["/units", "/units/lengthUnits", "/units/weightUnits"],
  },
  {
    path: "/FishDataTableView",
    icon: "fa-solid fa-table",
    title: "Table View",
    activeMatchPaths: ["/FishDataTableView", "/FishDataTableView/:id"],
  },
  {
    title: "Graph View",
    path: "/fish-data-graph-new",
    icon: "fas fa-chart-line",
    activeMatchPaths: [
      "/fish-data-graph-new",
      "/fish-data-graph-new/:pondDetailId",
      "/fish-data-graph",
      "/fish-data-graph/:pondDetailId",
    ],
  },
  {
    path: "/packages",
    icon: "fa-solid fa-boxes-packing",
    title: "Packages",
    activeMatchPaths: ["/packages"],
  },
  {
    path: "/coupons",
    icon: "fa-solid fa-ticket",
    title: "Coupons",
    activeMatchPaths: ["/coupons"],
  },
  {
    path: "/scientists",
    icon: "fa-solid fa-user-graduate",
    title: "Scientists",
    activeMatchPaths: ["/scientists", "/UpdateScientist/:id"],
  },
  {
    path: "/companies",
    icon: "fa-solid fa-building",
    title: "Companies",
    activeMatchPaths: ["/companies"],
  },
  {
    path: "/accounts",
    icon: "fa-solid fa-users",
    title: "Accounts",
    activeMatchPaths: ["/accounts", "/staff/:id", "/createStaff", "/UpdateStaff/:id", "/updateFisher/:id"],
  },
];

export default Menu;
